module.exports = __webpack_public_path__ + "img/pic-1.1c163598.png";